import {
	createDirectus,
	rest,
	authentication,
	readMe,
	refresh,
	type AuthenticationStorage,
} from "@directus/sdk"
import { useStorage } from "@vueuse/core"
export default defineNuxtPlugin(() => {

// const fields = manager.getDefaultDirectusPresets()
	const config = useRuntimeConfig()
	const defaultPresets: Record<string, any> = ColumnManager.getDefaultPresets()
	const userPresets = useStorage("userpresets", defaultPresets)
	// Миграция устаревших пресетов в localStorage: добиваем ключи таблиц,
	// которых не было на момент сохранения (иначе getBaseStats и страницы
	// падают на $userPresets.value[table].table).
	for (const [key, preset] of Object.entries(defaultPresets ?? {})) {
		if (userPresets.value?.[key] === undefined) {
			userPresets.value[key] = preset
		} else {
			// Добиваем новые поля по умолчанию в уже сохранённые пресеты.
			// Без этого обновления ColumnManager не применяются к существующим
			// настройкам в localStorage: страницы таблиц используют
			// $userPresets[table].table.params.fields напрямую.
			const defFields = preset?.table?.params?.fields
			const curParams = userPresets.value[key]?.table?.params
			if (Array.isArray(defFields) && curParams && Array.isArray(curParams.fields)) {
				const missing = defFields.filter((f) => !curParams.fields.includes(f))
				if (missing.length) curParams.fields = [...curParams.fields, ...missing]
			}
			// Добиваем новые ключи в etc (напр. showRightPanel) в уже сохранённые
			// настройки, иначе у существующих пользователей их не будет.
			if (key === 'etc' && preset && typeof preset === 'object') {
				for (const [k, v] of Object.entries(preset)) {
					if (userPresets.value[key]?.[k] === undefined) userPresets.value[key][k] = v
				}
			}
			// Добиваем новые ключи interface (напр. showShortNumber) в уже
			// сохранённые пресеты таблиц, иначе у существующих пользователей
			// их не будет и флаги отображения не сохранятся.
			const defIface = (preset as any)?.interface
			const curIface = (userPresets.value[key] as any)?.interface
			if (defIface && typeof defIface === 'object' && curIface && typeof curIface === 'object') {
				for (const [k, v] of Object.entries(defIface)) {
					if (curIface[k] === undefined) curIface[k] = v
				}
			}
		}
	}
	class NuxtCookieStorage {
		cookie = useCookie("directus-data", { maxAge: 2592000 })
		get() {
			return this.cookie.value
		}
		set(data: any) {
			this.cookie.value = data
		}
	}

	const storage = new NuxtCookieStorage() as AuthenticationStorage

	const directus = createDirectus<DirectusSchema>(config.public.directusUrl)
		.with(authentication("cookie", { credentials: "include", storage }))
		.with(rest({ credentials: "include" }))

	const isAuthenticated = async () => {
		try {
			const me = await directus.request(readMe())
			return me
		} catch (error) {
			console.error(error)
			return false
		}
	}


	const logout = async () => {
		await directus.logout()
		navigateTo("/auth")
	}

	return {
		provide: { directus, userPresets, isAuthenticated, logout, refresh },
	}
})
